'use client';
import styled from 'styled-components';

const Row = styled.tr``;

export default Row;
